import { useMemo } from 'react';
import { hasGate as defaultHasGate, hasScope as defaultHasScope, getAuth as defaultGetAuth, SCOPES } from '../utils/auth';
function makePermissions({
  hasScope
}) {
  return {
    isJitaUser: () => hasScope(SCOPES.jitaUser),
    hasDelete: () => hasScope(SCOPES.contract.delete),
    hasRead: () => hasScope(SCOPES.contract.read),
    hasWrite: () => hasScope(SCOPES.contract.write),
    hasAccess: () => hasScope(SCOPES.contract.access),
    canEditAssociation: (defaultEditAssociation = false) => defaultEditAssociation && hasScope(SCOPES.writeCRMAssociations) && hasScope(SCOPES.contract.write)
  };
}
export function useContractPermissions(api) {
  return useMemo(() => {
    var _api$hasScope, _api$hasGate, _api$getAuth;
    return makePermissions({
      hasScope: (_api$hasScope = api === null || api === void 0 ? void 0 : api.hasScope) !== null && _api$hasScope !== void 0 ? _api$hasScope : defaultHasScope,
      hasGate: (_api$hasGate = api === null || api === void 0 ? void 0 : api.hasGate) !== null && _api$hasGate !== void 0 ? _api$hasGate : defaultHasGate,
      getAuth: (_api$getAuth = api === null || api === void 0 ? void 0 : api.getAuth) !== null && _api$getAuth !== void 0 ? _api$getAuth : defaultGetAuth
    });
  }, [api === null || api === void 0 ? void 0 : api.hasScope, api === null || api === void 0 ? void 0 : api.hasGate, api === null || api === void 0 ? void 0 : api.getAuth]);
}